// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-36d882f7]  .popover {\n  width: 20px;\n}\n[data-v-36d882f7]  .popover .content {\n    width: 30px;\n    height: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
